// src/hooks/useDevice.ts
'use client';

import { DeviceType } from "@/types/device.type";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";

const useDevice = (mobile = 759, pc = 760) => {
  const [isClient, setIsClient] = useState(false);
  
  const isMobile = useMediaQuery({
    query: `(max-width:${mobile}px)`,
  });
  const isPc = useMediaQuery({
    query: `(min-width:${pc}px)`,
  });

  useEffect(() => {
    setIsClient(true);
  }, []);

  const getDevice = () => {
    if (!isClient) return DeviceType.PC; // 서버사이드에서의 기본값
    if (isMobile) return DeviceType.MO;
    return DeviceType.PC;
  };

  // 서버사이드 렌더링 시의 기본값 처리
  if (!isClient) {
    return {
      isMobile: false,
      isPc: true,
      getDevice: () => DeviceType.PC
    };
  }

  return { isMobile, isPc, getDevice };
};

export default useDevice;